import { useState } from 'react';

type ScopeCategory = 'admin' | 'dashboard' | null;

interface AdminConfirmation {
  /** The chosen role is the one that was confirmed. */
  confirmed: boolean;
  /** An Admin scope role is chosen and has not been confirmed yet, so the user cannot be saved. */
  needsConfirmation: boolean;
  toggle: () => void;
  /** Mark a role as already confirmed, for example the admin role a saved user already has. Empty text clears it. */
  setConfirmedRole: (role: string) => void;
}

/** Whether the person saving has confirmed the Admin scope warning for the role chosen now. Choosing a different role asks again. */
export function useAdminConfirmation(scopeCategory: ScopeCategory, selectedRole: string): AdminConfirmation {
  const [confirmedRole, setConfirmedRole] = useState('');
  const confirmed = confirmedRole !== '' && confirmedRole === selectedRole;
  return {
    confirmed,
    needsConfirmation: scopeCategory === 'admin' && !!selectedRole && !confirmed,
    toggle: () => setConfirmedRole(confirmed ? '' : selectedRole),
    setConfirmedRole,
  };
}
